// extracted by mini-css-extract-plugin
export var hidden = "_ux-0";